// Watch-out rows for the amber Watch-outs card (contracts/_watch_outs_card):
// the received-contract page (Phelipe 2026-08-28) and a sent upload's Ask AI
// panel (2026-10-23) render them the same way. Watch-outs arrive as objects
// (text / section / page / quote — clickable, the PDF scrolls to and
// highlights the clause through the host controller's #jumpWatchOut) or as
// plain strings from summaries cached before that existed.
export function watchOutsHtml(list, identifier, esc) {
  if (!Array.isArray(list) || !list.length) return ""
  return list.map(w => {
    if (typeof w === "string") {
      return `<div class="flex items-start gap-1.5 text-[13px] text-amber-800"><span class="mt-0.5 shrink-0">⚠</span><span>${esc(w)}</span></div>`
    }
    const meta = [w.section, w.page ? `p.${w.page}` : null].filter(Boolean).join(" · ")
    return `<button type="button" data-action="click->${identifier}#jumpWatchOut"
                    data-page="${esc(w.page || 1)}" data-quote="${esc(w.quote || "")}"
                    class="w-full flex items-start gap-1.5 text-[13px] text-amber-800 text-left rounded-lg px-1.5 py-1 -mx-1.5 hover:bg-amber-50 cursor-pointer"
                    title="Show me this clause in the PDF">
              <span class="mt-0.5 shrink-0">⚠</span>
              <span>${esc(w.text)}${meta ? ` <span class="text-amber-600/70 whitespace-nowrap">${esc(meta)}</span>` : ""}</span>
            </button>`
  }).join("")
}

// Show / hide the card around them (it stays hidden when there are none).
export function paintWatchOutsCard(card, list, html) {
  if (list) list.innerHTML = html
  if (!card) return
  card.classList.toggle("hidden", !html)
  card.classList.toggle("flex", !!html)
}
